import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { Observable, throwError, from, forkJoin } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ChaveConfiguracao } from './chave-configuracao.enum';
import { Ambiente } from './ambiente.model';
import { AmbienteConfig } from './ambiente.config';
import { ErrorHandlerService } from '../framework/error-handler.service';
import { Configuracao } from './configuracao.model';
import { InterceptorPreLogin } from '../framework/http-interceptor-prelogin';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AmbienteService {

  private static ambienteEstatico: Ambiente = null;

  constructor(
    private httpClient: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    private titleService: Title
  ) { }

  public getAmbiente(): Ambiente {
    if (!AmbienteService.ambienteEstatico) {
      this.inicializaAmbiente()
          .subscribe();
    }

    return AmbienteService.ambienteEstatico;
  }

  public criarInstanciaAmbiente(): Ambiente {
    AmbienteService.ambienteEstatico = new Ambiente();
    AmbienteService.ambienteEstatico.isAmbientePronto = false;
    return AmbienteService.ambienteEstatico;
  }

  fetch(chaveConfiguracao: ChaveConfiguracao): Observable<Configuracao> {
    const httpOptions = {
      headers: new HttpHeaders({}).append(InterceptorPreLogin, '')
    };
    return this.httpClient.get<Configuracao>(`/api/integracao/v1/configuracoes/${chaveConfiguracao}`, httpOptions)
                          .pipe(
                            catchError( err => throwError(this.errorHandlerService.handle(err)) )
                          );
  }

  buscarParametroDaConfiguracao?(configuracao: Configuracao, chaveParametro: string) {
    if (configuracao.parametros) {
      for (const parametro of configuracao.parametros) {
        if (parametro.chave === chaveParametro) {
          return parametro;
        }
      }
    }
    return {};
  }

  buscarVersaoAPI(): Observable<string> {
    return null;
  }

  inicializaAmbiente(): Observable<Ambiente> {
    if (AmbienteService.ambienteEstatico && AmbienteService.ambienteEstatico.isAmbientePronto) {
      return from ([this.getAmbiente()]);
    }
    else {
      this.criarInstanciaAmbiente().setKeyDS( AmbienteConfig.getKeyDS() );

      this.setupLogos();

      const configuracoesRequests$ = [];
      configuracoesRequests$.push(this.fetch(ChaveConfiguracao.AMBIENTE));
      configuracoesRequests$.push(this.fetch(ChaveConfiguracao.NON_DATABASE_VERSAO_API));

      return forkJoin(configuracoesRequests$)
        .pipe (
          map ( (configuracoes: Configuracao[]) => {
            configuracoes.forEach(configuracao => {
              switch (configuracao.chave) {
              case ChaveConfiguracao.AMBIENTE:
                const nome = this.buscarParametroDaConfiguracao(configuracao, 'NOME')['valor'];
                this.getAmbiente().setNome(nome);
              break;

              case ChaveConfiguracao.NON_DATABASE_VERSAO_API:
                const nonDatabaseVersaoApi = this.buscarParametroDaConfiguracao(configuracao, ChaveConfiguracao.NON_DATABASE_VERSAO_API.toString())['valor'];
                this.getAmbiente().setVersaoAPI(nonDatabaseVersaoApi);
              break;

              default:
              break;
              }
            });

            this.getAmbiente().isAmbientePronto = true;

            return this.getAmbiente();
          })
        );
    }
  }


  isGEEO(): boolean {
    const keyDS = this.getAmbiente().getKeyDS().toLowerCase();
    return (keyDS.startsWith('p2j_') || keyDS === 'dev');
  }

  setupLogos(): void {
    if ( this.isGEEO() ) {
      this.getAmbiente()
          .setArquivoLogoPequena('assets/layout/images/logo_p2j_pequena.png')
          .setArquivoLogoPequenaColorida('assets/layout/images/logo_p2j_pequena_colorida.png')
          .setArquivoLogoGrande('assets/layout/images/logo_p2j_grande.png')
          .setArquivoLogoGrandeHorizontal('assets/layout/images/logo_p2j_grande_horizontal.png')
          .setFavicon('assets/layout/images/favicon_p2j_colorida_fundo_branco.ico')
          .setNome('GEEO - Soluções para Saúde' + (environment.production ? '' : '(desenvolvimento)'));
    }
    else {
      this.getAmbiente()
          .setArquivoLogoPequena('assets/layout/images/hlog_clara.png')
          .setArquivoLogoPequenaColorida('assets/layout/images/healthlog.png')
          .setArquivoLogoGrande('assets/layout/images/healthlog.png')
          .setArquivoLogoGrandeHorizontal('assets/layout/images/healthlog.png')
          .setFavicon('assets/layout/images/favicon.ico')
          .setNome('HealthLog' + (environment.production ? '' : '(desenvolvimento)'));
    }

    this.titleService.setTitle(this.getAmbiente().getNome());
  }
}
